<template>
    <div>
        <form @submit.prevent="submit">
            <h4 class="mb-4 text-2xl font-bold">
                Survey Name
            </h4>
            <label class="block text-sm mb-8">
                <jet-input v-model="form.name"
                           type="text"

                           class=""
                           placeholder=""
                />
                <jet-input-error :message="form.errors?.name"></jet-input-error>
            </label>

            <h4 class="mb-4 text-2xl font-bold">
                Survey type
            </h4>
            <div class="mb-8 grid gap-6 md:grid-cols-2 max-w-2xl">
                <label v-for="surveyType in surveyTypes"
                       class="cursor-pointer flex justify-center text-center items-center px-8 py-7 leading-5 rounded-md focus:outline-none border border-dark"
                       :class="{
                            'bg-white': surveyType.id !== form.survey_type_id,
                            'bg-dark': surveyType.id === form.survey_type_id
                            }"
                >
                    <input v-model="form.survey_type_id" type="radio"
                           @change="checkAnswerOptions"
                           class="form-check rounded-sm border-2 w-5 h-5 focus:border-black focus:outline-none focus:shadow-outline-dark"
                           name="survey-type" :value="surveyType.id">
                    <span class="ml-4 text-xl font-bold"
                          :class="{
                                'text-dark' : surveyType.id !== form.survey_type_id,
                                'text-white': surveyType.id === form.survey_type_id
                            }">
                        {{ surveyType.type }}
                    </span>
                </label>
            </div>
            <!-- Overall Health Score Ratings -->
            <survey-template-score-ratings-editor
                :expanded="showOverallHealthScoreRatings"
                @toggle="showOverallHealthScoreRatings = !showOverallHealthScoreRatings"
                v-model:ratings="form.definition.scoreRatings"
                :errors="form.errors?.definition?.scoreRatings"
                ratings-title="Overall Health Score Ratings"
            />
            <!-- Add Sections -->
            <div class="sections">
                <template v-for="(section, sectionIndex) in form.definition.sections"
                          :key="'s-' + sectionIndex">
                    <div v-if="form.survey_type_id !== 1 || sectionIndex === 0"
                         class="section py-4 border dark:border-gray-600 border-gray-200 rounded-md px-8 mb-8">
                        <template v-if="form.survey_type_id !== 1">
                            <div class="mb-2 flex flex-row items-center justify-between">
                                <h4 class="text-xl font-bold text-gray-600 dark:text-gray-300">
                                    Section {{ sectionIndex + 1 }}
                                </h4>
                                <jet-button v-if="form.definition.sections.length > 1"
                                            @click.prevent="removeSection(sectionIndex)"
                                            :bg-dark="true"
                                >
                                    Delete Section
                                    <svg xmlns="http://www.w3.org/2000/svg" class="ml-2 h-5 w-5" fill="none"
                                         viewBox="0 0 24 24" stroke="white">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                                    </svg>
                                </jet-button>
                            </div>
                            <div class="flex mb-8">
                                <label class="block text-sm mb-2 w-1/3">
                                    <jet-input
                                        type="text"
                                        v-model="section.name"
                                        class=""
                                        placeholder="Section Name"
                                    />
                                    <jet-input-error
                                        :message="form.errors?.definition?.sections?.[sectionIndex]?.name"></jet-input-error>
                                </label>
                                <label class="block text-sm mb-2 pl-6 w-2/3">
                                    <jet-textarea
                                        v-model="section.description"
                                        placeholder="Section descriptive text"
                                        class=""
                                        rows="2"></jet-textarea>
                                </label>
                            </div>
                        </template>
                        <!-- Section Score Ratings -->
                        <survey-template-score-ratings-editor v-if="form.survey_type_id !== 1"
                                                              :expanded="showSectionScoreRatings[sectionIndex]"
                                                              @toggle="showSectionScoreRatings[sectionIndex] = !showSectionScoreRatings[sectionIndex]"
                                                              v-model:ratings="section.scoreRatings"
                                                              :errors="form.errors?.definition?.sections?.[sectionIndex]?.scoreRatings"
                                                              ratings-title="Section Score Ratings"
                        />

                        <!-- Add Questions -->
                        <h4 class="mb-4 text-xl font-bold text-gray-600 dark:text-gray-300">
                            Questions
                        </h4>
                        <!-- Questions per section -->
                        <div class="questions px-6">
                            <!-- Question -->
                            <div v-for="(question, questionIndex) in section.questions"
                                 :key="'s-' + sectionIndex + '-q-' + questionIndex"
                                 class="question mb-6 md:mt-0 md:col-span-2 bg-white shadow-md dark:bg-gray-800 rounded-md"
                            >
                                <div
                                    class="flex items-center justify-between px-4 py-3 bg-gray-100 dark:bg-gray-600 text-right border border-b-0 dark:border-gray-600 border-gray-200 sm:px-6 sm:rounded-tl-md sm:rounded-tr-md">
                                    <h4 class=" text-lg font-semibold text-gray-600 dark:text-gray-300">
                                        Question {{ questionIndex + 1 }}
                                        <template v-if="form.survey_type_id !== 1">(Section {{
                                                sectionIndex + 1
                                            }})
                                        </template>
                                    </h4>
                                    <jet-button v-if="section.questions.length > 1"
                                            @click.prevent="removeQuestion(sectionIndex, questionIndex)"
                                                :bg-dark="true"
                                    >
                                        Delete Question
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ml-2 h-4 w-4" fill="none"
                                             viewBox="0 0 24 24" stroke="white">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                                        </svg>
                                    </jet-button>
                                </div>
                                <div
                                    class="px-4 py-5 sm:p-6 sm:rounded-bl-md sm:rounded-br-md border dark:border-gray-600 border-gray-200">
                                    <div class="grid md:grid-cols-2 gap-6 px-6 py-4">
                                        <div class="">
                                            <h5 class="mb-4 font-semibold text-gray-600 dark:text-gray-300">
                                                Question
                                            </h5>
                                            <label class="block text-sm mb-3">
                                                <jet-textarea
                                                    v-model="question.content"
                                                    placeholder="Question text"
                                                    rows="2"></jet-textarea>
                                                <jet-input-error
                                                    :message="form.errors?.definition?.sections?.[sectionIndex]?.questions?.[questionIndex]?.content"></jet-input-error>
                                            </label>
                                            <label class="block text-sm mb-4">
                                                <jet-textarea
                                                    v-model="question.description"
                                                    placeholder="Question description"
                                                    rows="3"></jet-textarea>
                                            </label>
                                            <div class="">
                                                <h5 class="mb-4 font-semibold text-gray-600 dark:text-gray-300">
                                                    Question Type
                                                </h5>
                                                <div class="mt-2" v-for="surveyQuestionType in surveyQuestionTypes">
                                                    <label
                                                        class="inline-flex items-center text-gray-600 dark:text-gray-400">
                                                        <radio class=""
                                                               v-model="question.question_type"
                                                               :value="surveyQuestionType.id">
                                                            {{ surveyQuestionType.type }}
                                                        </radio>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="" v-if="question.question_type === 1">
                                            <!-- Question Answer Editor based on question type -->
                                            <component
                                                :is="'SurveyQuestionType' + question.question_type + 'AnswerEditor'"
                                                v-model:answers="question.answers"
                                                :errors="form.errors?.definition?.sections?.[sectionIndex]?.questions?.[questionIndex]?.answers"
                                            >
                                            </component>
                                        </div>
                                    </div>

                                    <!-- Question Score Ratings -->
                                    <survey-template-score-ratings-editor
                                        :expanded="showQuestionScoreRatings[sectionIndex + '-' + questionIndex]"
                                        @toggle="showQuestionScoreRatings[sectionIndex + '-' + questionIndex] = !showQuestionScoreRatings[sectionIndex + '-' + questionIndex]"
                                        v-model:ratings="question.scoreRatings"
                                        :errors="form.errors?.definition?.sections?.[sectionIndex]?.questions?.[questionIndex]?.scoreRatings"
                                        ratings-title="Question Score Ratings"
                                    />
                                </div>
                            </div>
                            <jet-button
                                @click.prevent="addNewQuestion(sectionIndex)"
                                :has-icon="true"
                            >
                                New Question
                            </jet-button>
                        </div>
                    </div>
                </template>
                <jet-button
                    v-if="form.survey_type_id !== 1"
                    :has-icon="true"
                    @click.prevent="addNewSection()"
                >
                    New Section
                </jet-button>
            </div>

            <div class="grid gap-6 grid-cols-2">
                <jet-button
                    @click="saveTemplate"
                    :disabled="form.processing"
                    class="block w-full mt-8 p-6 text-center"
                    :bg-dark="true"
                >
                    Save Survey Template
                </jet-button>
                <jet-button
                    @click.prevent="previewReport"
                    :disabled="form.processing"
                    class="block w-full mt-8 p-6 text-center"
                    :bg-dark="true"
                >
                    Preview Survey Report
                </jet-button>
            </div>
            <jet-button v-if="form.status !== 1"
                        @click="saveAndPublishTemplate"
                        :disabled="form.processing"
                        class="block w-full mt-8 p-6 text-center"
                        :bg-dark="true"
            >
                Save & Publish Survey Template
            </jet-button>
        </form>
    </div>
</template>

<script>
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import {useForm} from '@inertiajs/inertia-vue3';
import JetButton from "@/Jetstream/Button";
import JetTextarea from "@/Jetstream/Textarea";
import Radio from "@/Jetstream/Radio";
import {inject, reactive, ref} from "vue";
import SurveyTemplateScoreRatingsEditor from "@/Components/SurveyTemplateEditor/SurveyTemplateScoreRatingsEditor";
import SurveyQuestionType1AnswerEditor from "@/Components/SurveyTemplateEditor/SurveyQuestionType1AnswerEditor";

export default {
    name: "SurveyTemplateEditor",
    components: {
        SurveyTemplateScoreRatingsEditor,
        JetInput,
        JetButton,
        JetTextarea,
        SurveyQuestionType1AnswerEditor,
        JetInputError,
        Radio,
    },
    props: {
        surveyTypes: {
            type: Object,
            required: true,
        },
        surveyQuestionTypes: {
            type: Array,
            required: true,
        },
        surveyTemplateModel: {
            type: Object,
            required: false,
        },
        answerLabelOptions: {
            type: Object,
            required: false,
        }
    },
    setup(props) {
        const defaultAnswerOptions = {};
        props.surveyTypes.forEach((surveyType) => {
            if (!defaultAnswerOptions[surveyType.id]) {
                defaultAnswerOptions[surveyType.id] = {};
            }
            props.surveyQuestionTypes.forEach((questionType) => {
                if (!props.answerLabelOptions
                    || !props.answerLabelOptions[surveyType.id]
                    || !props.answerLabelOptions[surveyType.id][questionType.id]) {
                    switch (questionType.id) {
                        case 1:
                            defaultAnswerOptions[surveyType.id][questionType.id] = {
                                1: {
                                    bgColor: null,
                                    textColor: null,
                                    label: '',
                                },
                                2: {
                                    bgColor: null,
                                    textColor: null,
                                    label: '',
                                },
                                3: {
                                    bgColor: null,
                                    textColor: null,
                                    label: '',
                                },
                                4: {
                                    bgColor: null,
                                    textColor: null,
                                    label: '',
                                },
                                5: {
                                    bgColor: null,
                                    textColor: null,
                                    label: '',
                                },
                            };
                            break;
                        default:
                            defaultAnswerOptions[surveyType.id][questionType.id] = {};
                            break;
                    }
                } else {
                    defaultAnswerOptions[surveyType.id][questionType.id] = props.answerLabelOptions[surveyType.id][questionType.id];
                }
            });
        });

        const newAnswers = (questionType) => {
            return _.cloneDeep(defaultAnswerOptions[form?.survey_type_id ?? 1][questionType]);
        };

        const newQuestion = () => {
            return {
                content: '',
                description: '',
                ref: 'question-' + Date.now(),
                question_type: 1,
                answers: newAnswers(1),
                scoreRatings: newScoreRatings(),
            };
        };

        const newScoreRatings = () => {
            return [
                {
                    min_percent: 0,
                    bgColor: '#cc1719',
                    textColor: '#ffffff',
                    label: 'Action needed',
                    description: '',
                }, {
                    min_percent: 34,
                    bgColor: '#f9bc17',
                    textColor: '#ffffff',
                    label: 'Needs work',
                    description: '',
                },
                {
                    min_percent: 67,
                    bgColor: '#12d4b8',
                    textColor: '#ffffff',
                    label: 'All good',
                    description: '',
                }
            ];
        }

        const newSection = () => {
            return {
                name: '',
                description: '',
                ref: 'section-' + Date.now(),
                questions: [
                    newQuestion(),
                ],
                scoreRatings: newScoreRatings(),
            };
        };

        const form = props.surveyTemplateModel
            ? useForm({
                id: props.surveyTemplateModel.id,
                name: props.surveyTemplateModel.name,
                survey_type_id: props.surveyTemplateModel.survey_type_id,
                definition: _.cloneDeep(props.surveyTemplateModel.definition),
                status: props.surveyTemplateModel.status,
                publish: false,
            })
            : useForm({
                id: null,
                name: '',
                survey_type_id: 1,
                definition: {
                    ref: 'survey-' + Date.now(),
                    sections: [
                        newSection()
                    ],
                    scoreRatings: newScoreRatings(),
                },
                status: 0,
                publish: false,
            });

        const addNewSection = () => {
            form.definition.sections.push(newSection());
        };

        const removeSection = (sectionIndex) => {
            form.definition.sections.splice(sectionIndex, 1);
        };

        const addNewQuestion = (sectionIndex) => {
            form.definition.sections[sectionIndex].questions.push(newQuestion());
        };

        const removeQuestion = (sectionIndex, questionIndex) => {
            form.definition.sections[sectionIndex].questions.splice(questionIndex, 1);
        };

        const saveTemplate = () => {
            form.publish = false;
        };

        const saveAndPublishTemplate = () => {
            form.publish = true;
        };

        const parseErrors = (errorsObject) => {
            Object.keys(errorsObject).forEach(function (key) {
                const prop = key.split('.');
                const last = prop.pop();

                prop.reduce(function (object, keyPart) {
                    return object[keyPart] = object[keyPart] || {};
                }, errorsObject)[last] = errorsObject[key];

                if (last !== key) {
                    delete errorsObject[key];
                }
            });

            return errorsObject;
        };

        const submit = () => {
            if (!form.id) {
                form.post(route('admin.survey.templates.store'), {
                    onFinish: () => {
                        afterFormSubmit();
                    }
                });
            } else {
                form.put(route('admin.survey.templates.update', {template: form.id}), {
                    onFinish: () => {
                        afterFormSubmit();
                    }
                });
            }
        };

        const afterFormSubmit = () => {
            if (form.hasErrors) {
                document.querySelector('#mainContent').scrollTo(0, 0);
                form.errors = parseErrors(form.errors);
                $toast.error('There were errors with the submitted data! Please fix them and try again!');
                if (form.errors?.definition?.scoreRatings) {
                    showOverallHealthScoreRatings.value = true;
                }
                if (form.errors?.definition?.sections) {
                    Object.entries(form.errors?.definition?.sections)
                        .forEach(([sectionIndex, sectionErrors]) => {
                            if (sectionErrors?.scoreRatings) {
                                showSectionScoreRatings[sectionIndex] = true;
                            }
                            if (sectionErrors?.questions) {
                                Object.entries(sectionErrors?.questions)
                                    .forEach(([questionIndex, questionErrors]) => {
                                        if (questionErrors?.scoreRatings) {
                                            showQuestionScoreRatings[sectionIndex + '-' + questionIndex] = true;
                                        }
                                    });
                            }
                        });
                }
            }
        }

        const checkAnswerOptions = () => {
            if (form.definition.sections.length === 1
                && form.definition.sections[0].questions.length === 1) {
                //if the user only just started the template and changed its type then we update the labels
                form.definition.sections[0].questions[0].answers = newAnswers(form.definition.sections[0].questions[0].question_type);
            }
        };

        const showSectionScoreRatings = reactive({});

        const showQuestionScoreRatings = reactive({});

        const showOverallHealthScoreRatings = ref(false);

        const $toast = inject('$toast');
        const $swal = inject('$swal');

        const previewReport = () => {
            form.processing = true;
            $swal({
                title: 'What score percentage should the preview be generated for?',
                input: 'number',
                inputAttributes: {
                    autocapitalize: 'off',
                    max: 100,
                    min: 0,
                },
                showCancelButton: true,
                confirmButtonText: 'Generate report preview',
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !Swal.isLoading(),
                validationMessage: 'The rating has to be a number between 0 and 100!',
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post(route('admin.survey.templates.preview-report'),
                        {
                            previewScoreValue: result.value,
                            ...form.data()
                        }, {
                            responseType: 'blob',
                        })
                        .then((response) => {
                            form.processing = false;
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'previewReport.pdf');
                            document.body.appendChild(link);
                            link.click();
                        })
                        .catch(async (error) => {
                            if (error.response.status === 422) {
                                Object.entries(JSON.parse(await error.response.data.text()).errors)
                                    .forEach(([key, value]) => form.errors[key] = value[0]);
                                form.hasErrors = true;
                                form.processing = false;
                                $toast.error('Report preview could not be generated!');
                                afterFormSubmit();
                            } else {
                                form.processing = false;
                            }
                        });
                } else {
                    form.processing = false;
                }
            });
        }

        return {
            form,
            addNewSection,
            removeSection,
            addNewQuestion,
            removeQuestion,
            submit,
            saveTemplate,
            saveAndPublishTemplate,
            checkAnswerOptions,
            showOverallHealthScoreRatings,
            showSectionScoreRatings,
            showQuestionScoreRatings,
            previewReport,
        }
    }
}
</script>

<style lang="scss">
@import "resources/sass/ck-editor-dark";
@import "resources/sass/ck-content";
</style>
